import Smartlook from 'smartlook-client';
import { isDev, isProductionEnv } from 'src/api';

const isEnabled = !isDev && isProductionEnv;
const isDebug = localStorage.getItem('smartlookDebug') === 'true';

const smartlookInit = () => {
  if (!isEnabled) return;
  const result = Smartlook.init('e0f767aa745b64c9337475bfe7edc6ae41985fb3', { region: 'eu' });
  if (isDebug) console.debug('[Smartlook] init: ', { result });
};

const smartlookRecordNumbers = () => {
  if (!isEnabled) return;
  Smartlook.record({ forms: true, numbers: true, emails: true, ips: true });
};

const smartlookIdentify = (userId: string, userEmail: string) => {
  if (!isEnabled) return;
  if (!Smartlook.initialized()) {
    console.error('[Smartlook] is not initialized: ');
    smartlookInit();
  }
  if (isDebug) console.debug('[Smartlook]: indentify', { userId, email: userEmail });
  Smartlook.identify(userId, { email: userEmail });
};

export { smartlookIdentify, smartlookRecordNumbers, smartlookInit };
